<template>
  <div class="notice">
    <h2 class="text-center">注意事項</h2>
    <ul class="my-6">
      <li>
        根元染めは、頭皮から3cm迄でそれ以上の場合追加のカラー剤として550円を頂戴いたします。
      </li>
      <li>
        全体染めは、髪の長さによって料金が変わります。
      </li>
      <li>
        施術後は、セルフブローとなります。
      </li>
    </ul>

    <RequiredMark />
    <span class="text">
      下記の内容について、1つずつご確認の上、チェックもしくはYes/Noをご記入ください。
    </span>
    <div class="mb-5">
      <template v-for="(agree, idx) in agreements">
        <v-layout v-if="hideInput" :key="idx" class="py-3">
          <v-flex shrink class="pr-3">
            <v-icon color="red">mdi-check</v-icon>
          </v-flex>
          <v-flex class="primary--text agree-text" v-html="agree.text" />
        </v-layout>
        <v-checkbox
          v-else
          :key="idx"
          v-model="agree.value"
          color="primary"
          hide-details
          @change="checkAgree"
        >
          <span
            slot="label"
            class="primary--text agree-text"
            v-html="agree.text"
          />
        </v-checkbox>
      </template>
    </div>

    <RequiredMark />
    <span class="text">
      パッチテストの実施をご希望されますか(実施した場合、48時間以内は施術ができません)
    </span>

    <v-layout v-if="!hideInput">
      <v-flex>
        <v-checkbox
          :input-value="patchTest"
          color="primary"
          hide-details
          on-icon="mdi-check-circle"
          off-icon="mdi-radiobox-blank"
          @change="$emit('update:patch-test', $event)"
        >
          <span slot="label" class="primary--text agree-text">
            実施する
          </span>
        </v-checkbox>
      </v-flex>
      <v-flex>
        <v-checkbox
          :input-value="patchTest === null ? false : !patchTest"
          color="primary"
          hide-details
          on-icon="mdi-check-circle"
          off-icon="mdi-checkbox-blank-circle-outline"
          @change="$emit('update:patch-test', !$event)"
        >
          <span slot="label" class="primary--text agree-text">
            実施しない
          </span>
        </v-checkbox>
      </v-flex>
    </v-layout>
    <v-layout v-else class="mt-4">
      <v-flex>
        <span v-if="patchTest" class="primary--text agree-text">
          実施する
        </span>
      </v-flex>
      <v-flex>
        <span v-if="!patchTest" class="primary--text agree-text">
          実施しない
        </span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import RequiredMark from './RequiredMark'

export default {
  name: 'NoticeCheck',
  components: {
    RequiredMark,
  },
  props: {
    patchTest: {
      type: Boolean,
      default: null,
    },
    noticeChecks: {
      type: Boolean,
      default: false,
    },
    hideInput: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    agreements: [
      {
        value: false,
        text: 'ヘナ・マニキュア・ブリーチなどは取り扱っておりません。',
      },
      {
        value: false,
        text:
          'アルカリカラーの均一カラー以外（ハイライト・グラデーションカラーなど）はメニューとして実施しておりません。',
      },
      {
        value: false,
        text:
          '髪の状態（利尻カラー、ブリーチによるダメージ毛、黒染めなど）によって、 <br />スタッフが施術不可と判断した場合は、施術をお断りする事がございます。',
      },
      {
        value: false,
        text:
          'アレルギー反応やかぶれなど、何らかの症状が出た場合、一切の責任を負いかねます。',
      },
      {
        value: false,
        text: 'お手荷物の紛失についても、一切の責任を負いかねます。',
      },
    ],
  }),
  watch: {
    noticeChecks: {
      immediate: true,
      handler(value) {
        if (value)
          this.agreements.forEach(x => {
            x.value = value
          })
      },
    },
  },
  methods: {
    checkAgree() {
      // console.log('agree', !this.agreements.some(x => !x.value))
      this.$emit('update:notice-checks', !this.agreements.some(x => !x.value))
    },
  },
}
</script>

<style lang="scss" scoped>
.notice {
  color: #370014;
  background-color: #fefbdb;
  font-weight: bold;
  padding: 32px 6px;
  .text {
    font-weight: normal;
    color: rgba(0, 0, 0, 0.54);
  }
}
.agree-text {
  font-size: 14px;
  font-weight: bold;
}
</style>
